import React, { useState } from "react";

/**
 * Renders the Inventya brand mark, automatically choosing a light-mode or
 * dark-mode variant. Pass `forceLight` when the surrounding area is always dark
 * (e.g. the sign-in hero or the site footer) — the light variant is rendered
 * unconditionally, regardless of the app theme.
 */
export default function BrandLogo({ className = "h-11 w-auto object-contain", forceLight = false }) {
  const [lightLogoOk, setLightLogoOk] = useState(true);

  // Always-light rendering for permanently-dark surfaces
  if (forceLight) {
    return lightLogoOk ? (
      <img
        src="/brand/inventya-logo-light.png"
        alt="Inventya"
        className={className}
        onError={() => setLightLogoOk(false)}
      />
    ) : (
      <img
        src="/brand/inventya-logo.png"
        alt="Inventya"
        className={`${className} dark-invert-logo`}
      />
    );
  }

  return (
    <>
      {/* Light theme */}
      <img
        src="/brand/inventya-logo.png"
        alt="Inventya"
        className={`${className} block dark:hidden`}
      />
      {/* Dark theme */}
      {lightLogoOk ? (
        <img
          src="/brand/inventya-logo-light.png"
          alt="Inventya"
          className={`${className} hidden dark:block`}
          onError={() => setLightLogoOk(false)}
        />
      ) : (
        <img
          src="/brand/inventya-logo.png"
          alt="Inventya"
          className={`${className} hidden dark:block dark-invert-logo`}
        />
      )}
    </>
  );
}
